import he from 'he';

export function EventDetails(props){
    //
    return(
        <>
            {/*<h1>Event Details</h1>*/}
            {/*<p>Current event id = {props.currentEventID}</p>*/}
            {
                props.eventList.filter(event => event.id == props.currentEventID).map(filteredEvent => (
                    <>
                    <div class="row experience-wrapper mt-md-6 gx-md-5">
                        <div class="col-md-4 mb-4 mb-md-0">
                            {filteredEvent.featured_media > 0 && <img src={filteredEvent._embedded['wp:featuredmedia']['0'].source_url} alt="" />}
                        </div>
                        <div class="col-md-8">
                            <h2><a href={filteredEvent.link} class="text-primary">{he.decode(filteredEvent.title.rendered)}</a></h2>
                            <div dangerouslySetInnerHTML={{ __html: filteredEvent.acf.event_description }} />
                            <p class="text-primary"><strong>From £{filteredEvent.acf.price}pp</strong></p>
                            <p><a href={filteredEvent.acf.booking_url} className="btn btn-primary" target="_blank">Book here</a></p>
                        </div>
                    </div>
                    </>
                ))
            }
        </>
    )
}